import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { MessageCircle, Star } from 'lucide-react';
import { PCT_REFERIDO, bodasApi, mensajeError, urlReferido, waLink } from '../bodasUtils';
import BuscadorCliente from './BuscadorCliente';
import { BotonCopiar, Panel, Vacio } from './comunes';

const mensajeCliente = (nombre, url, puntos, pct) =>
  `Hola ${nombre?.split(' ')[0] || ''}, este es tu enlace personal de referidos de Juan Pablo Murillo: ${url}\n\nCompártelo con tus amigos: cada persona que llegue por tu enlace recibe ${pct}% de descuento en su primera compra y tú ganas ${puntos} Puntos JPM cuando compre.`;

const telefonoWa = (tel) => {
  const d = (tel || '').replace(/\D/g, '');
  return d.length === 10 ? `57${d}` : d;
};

const EnlaceGenerado = ({ dato, puntos }) => {
  const url = urlReferido(dato.tarjeta.codigo);
  const wa = waLink(telefonoWa(dato.cliente.telefono), mensajeCliente(dato.cliente.nombre, url, puntos, dato.tarjeta.beneficio_valor));
  return (
    <div className="mt-4 rounded-lg border border-emerald-200 bg-emerald-50 p-4" data-testid="enlace-generado">
      <p className="text-sm font-medium text-emerald-900">Enlace de {dato.cliente.nombre}</p>
      <p className="mt-1 break-all font-mono text-sm text-emerald-800" data-testid="enlace-generado-url">{url}</p>
      <p className="mt-2 text-xs text-emerald-800">Beneficio fijo para quien llegue por este enlace: {dato.tarjeta.beneficio_texto.replace('Tienes un ', '')}.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <BotonCopiar texto={url} testId="enlace-generado-copiar" />
        {wa && <button type="button" onClick={() => window.open(wa, '_blank', 'noopener')} className="inline-flex items-center gap-1.5 rounded-lg bg-emerald-700 px-3 py-2 text-sm font-medium text-white hover:bg-emerald-800" data-testid="enlace-generado-whatsapp"><MessageCircle className="h-4 w-4" />Enviar al cliente por WhatsApp</button>}
      </div>
    </div>
  );
};

const FilaTarjeta = ({ t }) => (
  <li className="flex flex-col gap-2 px-4 py-3 sm:flex-row sm:items-center sm:justify-between" data-testid={`tarjeta-fila-${t.codigo}`}>
    <div className="min-w-0">
      <p className="font-medium text-slate-800">{t.cliente.nombre} <span className="text-xs font-normal text-slate-500">{t.cliente.id_cliente}</span></p>
      <p className="text-xs text-slate-500">
        {t.referidos} registrados · {t.ventas} compraron · <span className="inline-flex items-center gap-0.5 font-medium text-amber-800"><Star className="h-3 w-3" fill="currentColor" />{t.puntos} pts ganados</span>
      </p>
    </div>
    <BotonCopiar texto={urlReferido(t.codigo)} testId={`tarjeta-copiar-${t.codigo}`} />
  </li>
);

export default function EnlacesClientes() {
  const [lista, setLista] = useState({ tarjetas: [], puntos_por_referido: 200 });
  const [generado, setGenerado] = useState(null);

  const cargar = useCallback(() => {
    bodasApi.tarjetas().then(setLista).catch(e => toast.error(mensajeError(e, 'No se pudieron cargar los enlaces')));
  }, []);
  useEffect(() => { cargar(); }, [cargar]);

  const elegir = async (cliente) => {
    if (!cliente) { setGenerado(null); return; }
    try { setGenerado(await bodasApi.generarTarjeta(cliente.id)); cargar(); }
    catch (e) { toast.error(mensajeError(e, 'No se pudo generar el enlace')); }
  };

  return (
    <div className="grid gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)]">
      <Panel className="p-5" testId="enlaces-generar">
        <h2 className="font-semibold text-slate-800">Generar enlace de referidos</h2>
        <p className="mt-1 text-sm text-slate-500">Cada cliente tiene un enlace único. Quien llegue por él recibe {PCT_REFERIDO}% de descuento en su primera compra, y el cliente gana {lista.puntos_por_referido} Puntos JPM por cada uno que compre.</p>
        <div className="mt-4">
          <BuscadorCliente seleccionado={generado?.cliente} onSeleccionar={elegir} label="Cliente que va a compartir el enlace" testId="enlaces-cliente" />
        </div>
        {generado && <EnlaceGenerado dato={generado} puntos={lista.puntos_por_referido} />}
      </Panel>
      <Panel testId="enlaces-lista">
        <h2 className="border-b border-slate-100 px-4 py-3 font-semibold text-slate-800">Clientes con enlace</h2>
        {!lista.tarjetas.length ? <Vacio testId="enlaces-vacio">Todavía no hay enlaces generados.</Vacio> : (
          <ul className="divide-y divide-slate-100">{lista.tarjetas.map(t => <FilaTarjeta key={t.codigo} t={t} />)}</ul>
        )}
      </Panel>
    </div>
  );
}
